// extracted by mini-css-extract-plugin
module.exports = {"body":"SelectOwnerForRegistrationModal_body__2qfz7"};